import {
  SidePanelDS,
  TextCapitalized,
  Avatar,
  Spacer,
  RemoveRedEyeOutlined,
  Tag,
} from "@qivia/ui";
import { LittleCardAsset } from "@qivia/ui/src/assets/assets";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { PublicTransactionsPropsType } from "../transactionsAPI";
import { colors } from "@qivia/ui/src/styles/figmaColors";

export const SidePanelSectionBlock = (props: {
  transaction: PublicTransactionsPropsType;
  canRedirectToRule: boolean;
  firstPath: string;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SidePanelDS.ActionBlock>
      <>
        {props.transaction.driverName && props.transaction.driverLastName && (
          <SidePanelDS.SectionedActionStripe
            left={
              <StyledRowCenter>
                <TextCapitalized>
                  <Avatar
                    size={"S"}
                    color={"orange"}
                    firstName={props.transaction.driverName[0]}
                    lastName={props.transaction.driverLastName[0]}
                  />
                </TextCapitalized>
                <Spacer x={0.5} />
                {props.transaction.driverName}
              </StyledRowCenter>
            }
            right={
              <StyledLittleIcon>
                <RemoveRedEyeOutlined
                  key="driver"
                  onClick={() =>
                    navigate(
                      `/${props.firstPath}/drivers/${props.transaction.driver}?fromNavigate=true`,
                    )
                  }
                />
                <Spacer x={1} />
              </StyledLittleIcon>
            }
          />
        )}
      </>
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRow>
            <LittleCardAsset />
            <Spacer x={1} />
            {`**** ${props.transaction.cardLast4Digits.toString()}`}
          </StyledRow>
        }
        right={
          <StyledLittleIcon>
            <RemoveRedEyeOutlined
              key="card"
              onClick={() =>
                navigate(
                  `/${props.firstPath}/cards/cards/${props.transaction.cardUuid}?fromNavigate=true`,
                )
              }
            />
            <Spacer x={1} />
          </StyledLittleIcon>
        }
      />
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRowCenter>
            {props.transaction.registrationNumber}
            {props.transaction.vehicleReference && (
              <>
                <Spacer x={1} />
                <Tag
                  textColor={colors["colors/text/darkGrey"]}
                  text={props.transaction.vehicleReference}
                  backgroundColor={
                    colors["colors/surfaces/background/background_level0"]
                  }
                  borderColor={colors["colors/text/darkGrey"]}
                />
              </>
            )}
          </StyledRowCenter>
        }
        right={
          <StyledLittleIcon>
            <RemoveRedEyeOutlined
              key="vehicle"
              onClick={() =>
                navigate(
                  `/${props.firstPath}/vehicles/${props.transaction.vehicleUuid}?fromNavigate=true`,
                )
              }
            />
            <Spacer x={1} />
          </StyledLittleIcon>
        }
      />
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRowCenter>
            <StyledBodyM>
              <TextCapitalized>
                {t(`cards.sidePanel.informations.title.rule`)}
              </TextCapitalized>
            </StyledBodyM>
            <Spacer x={0.5} />
            {props.transaction.ruleName}
          </StyledRowCenter>
        }
        right={
          props.canRedirectToRule && (
            <StyledLittleIcon>
              <RemoveRedEyeOutlined
                key="rule"
                onClick={() =>
                  navigate(
                    `/${props.firstPath}/rule/${props.transaction.ruleUuid}`,
                  )
                }
              />
              <Spacer x={1} />
            </StyledLittleIcon>
          )
        }
      />
    </SidePanelDS.ActionBlock>
  );
};

const StyledRow = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledRowCenter = styled.div`
  ${typographies["Body/S"]}
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
const StyledLittleIcon = styled.div`
  display: flex;
  cursor: pointer;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;

const StyledBodyM = styled.div`
  ${typographies["Body/M"]}
`;
